<template>
  <v-form @submit.prevent="submit">
    <v-card>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <span class="grey--text">Тип профиля</span>
              <v-select
                v-model="profileType"
                item-value="value"
                item-text="text"
                :items="$options.listProfileTypes"
                hide-details
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="grey--text">
                Название или имя профиля
              </span>
              <Autocomplete
                v-model="name"
                item-value="id"
                item-text="name"
                :states="profileNames"
                :disabled="isDisabledName"
                @change="setProfileId"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="grey--text">
                Телефон/email пользователя
              </span>
              <Autocomplete
                v-model="user"
                item-value="id"
                item-text="login"
                :states="accountsList"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="mt-auto">
        <v-spacer />
        <v-btn
          block
          color="success darken-2"
          type="submit"
          :disabled="isDisabledSubmit"
        >
          Пригласить
        </v-btn>
      </v-card-actions>
      <v-card-actions class="mt-auto">
        <v-btn
          width="100%"
          type="button"
          text
          color="grey darken-1"
          @click="$emit('cancel')"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import FormAbstract from '@/components/abstract/form'
import Autocomplete from '@/components/inputs/Autocomplete'
import { listProfileTypes } from '@/configs/profileTypes'
import { queries, variables, returnName } from '@/configs/profileQuery.js'
import accountsGridQueries from '@/services/gql/types/Accounts/queries/accountsGrid.gql'
import createSharedAccessMutation from '@/services/gql/types/SharedAccess/mutations/createSharedAccess.gql'

export default {
  name: 'FormSharedAccess',
  listProfileTypes,
  extends: FormAbstract,
  components: {
    Autocomplete
  },
  data () {
    return {
      profileType: null,
      profileId: null,
      name: null,
      user: '',
      profileNames: [],
      accountsList: [],
      error: []
    }
  },
  computed: {
    isDisabledName () {
      return this.disabled || !this.profileType?.length
    },
    isDisabledSubmit () {
      return !this.profileType || !this.profileId || !this.user
    },
    isPhone () {
      if (this.user === null) { return false }
      return this.user.match(/^[\d+]/m)
    }
  },
  watch: {
    profileType () {
      this.name = null
      this.profileNames = []
      this.profileId = null
    }
  },
  methods: {
    setProfileId (value) {
      this.profileId = +value
    },
    async submit () {
      try {
        if (!(this.profileType && this.profileId && this.user)) { return }
        const { data } = await this.$async.createSharedAccessMutation.$perform({
          data: {
            [this.isPhone ? 'phone' : 'email']: this.isPhone ? this.user.match(/\d/g).join('') : this.user,
            profileId: this.profileId,
            profileType: this.profileType
          }
        })
        if (data.createSharedAccess) {
          this.$emit('submit')
        }
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'shared-access.create')
      }
    }
  },
  async: {
    createSharedAccessMutation (variables) {
      return this.$apollo.mutate({
        mutation: createSharedAccessMutation,
        variables
      })
    }
  },
  apollo: {
    profileNames: {
      query () { return this.profileType ? queries[this.profileType] : queries.GUIDE },
      fetchPolicy: 'network-only',
      manual: true,
      skip () { return !this.name?.length || !this.profileType?.length },
      variables () {
        return this.profileType
          ? variables(this.name)[this.profileType]
          : variables(this.name).GUIDE
      },
      result ({ data }) {
        if (data && data[Object.keys(data)[0]].list?.length) {
          this.profileNames = data[Object.keys(data)[0]].list.map((profile) => {
            return {
              id: profile.id,
              name: profile[returnName[this.profileType]]
            }
          })
        } else { this.profileNames = [] }
      }
    },
    accountsList: {
      query: accountsGridQueries,
      fetchPolicy: 'network-only',
      manual: true,
      skip () { return !this.user?.length },
      variables () {
        return {
          where: {
            [this.isPhone ? 'phone_contains' : 'email_contains']:
              this.isPhone ? this.user.match(/\d/g).join('') : this.user
          }
        }
      },
      result ({ data }) {
        this.accountsList = data?.accounts?.list.map(user => {
          return {
            ...user,
            login: this.isPhone ? user.phone : user.email
          }
        })
      }
    }
  }
}
</script>
